define(["require", "exports", "jquery", "knockout", "log", "../../utils/tools", "../../models/ServerModel", "../../models/ServerPasswordModel", "../../models/UserContext"], function (require, exports, $, ko, log, tools, ServerModel, ServerPasswordModel, UserContext) {
    "use strict";
    var ServerActions = /** @class */ (function () {
        function ServerActions() {
            this.editModel = ko.observable(new ServerModel());
            this.deleteModel = ko.observable(new ServerModel());
            this.passwordModel = ko.observable(new ServerPasswordModel());
            this.canUserSeePassword = ko.observable(UserContext.hasAccess("Servers.AllowSeePassword") || UserContext.hasAccess("Admin") || UserContext.hasAccess("Servers.Edit") || UserContext.hasAccess("Servers.Delete"));
        }
        ServerActions.prototype.init = function () {
        };
        ServerActions.prototype.editServer = function (theId, name) {
            var self = this;
            var title = "Add Server";
            if ($.isNumeric(theId) && name) {
                title = "Edit Server " + name + " Details";
            }
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    if (!self.editModel().IpAddress()) {
                        tools.error("Ip Address is required");
                        return;
                    }
                    if (!self.editModel().ServerGroupId()) {
                        tools.error("Server Group is required");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.saveServer(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if ($.isNumeric(theId)) {
                        getModelCall = tools.ajaxGet({
                            url: "/Servers/GetById",
                            data: { id: theId },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new ServerModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new ServerModel());
                    }
                    var getLookupData = tools.ajaxGet({
                        url: "/Servers/GetServerLookupData",
                        success: function (data) {
                            if (data.Success) {
                                self.lookupLists = data.Data.lookupLists;
                            }
                            else {
                                log.error(data.Error);
                            }
                        }
                    });
                    $.when(getModelCall, getLookupData).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'server-edit-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                        self.groupsDropDownList = $("#GroupId", modal).kendoComboBox({
                            autoBind: false,
                            valuePrimitive: true,
                            filter: "contains",
                            placeholder: "Select server group...",
                            dataTextField: "ServerGroupName",
                            dataValueField: "Id",
                            dataSource: {
                                transport: {
                                    read: {
                                        url: "/ServersGroups/GetGroups",
                                        type: "POST",
                                        dataType: "json"
                                    }
                                },
                                schema: {
                                    data: function (response) { return response.Data; },
                                    total: "Total"
                                },
                                serverFiltering: true
                            },
                            dataBound: function () {
                            },
                            cascade: function (e) {
                                if (self.groupsDropDownList.dataItem()) {
                                    self.editModel().ServerGroupId(self.groupsDropDownList.dataItem().Id);
                                }
                                else {
                                    if (self.editModel().ServerGroupId()) {
                                        self.editModel().ServerGroupId(null);
                                    }
                                }
                            }
                        }).data("kendoComboBox");
                        self.groupsDropDownList.wrapper.width("100%");
                        self.groupsDropDownList.value(self.editModel().ServerGroupId());
                    });
                }
            });
        };
        ServerActions.prototype.saveServer = function (btn, modal) {
            var _this = this;
            var self = this;
            var obj = ko.mapping.toJS(self.editModel);
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/Servers/SaveServer",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    if (_this.saveCallback) {
                        _this.saveCallback(result.Data);
                    }
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        ServerActions.prototype.deleteServerConfirm = function (theId, name) {
            var self = this;
            self.deleteModel(new ServerModel());
            self.deleteModel().Id(theId);
            self.deleteModel().IpAddress(name);
            tools.editModal({
                title: "Delete Server - " + name,
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {},
                save: function (event, modal) {
                    $(event.currentTarget).button("loading");
                    self.deleteServer(event.currentTarget, modal);
                },
                opened: function (modal) {
                    $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'server-remove-template', data: deleteModel }\"></div>");
                    ko.applyBindings(self, modal);
                }
            });
        };
        ServerActions.prototype.deleteServer = function (btn, modal) {
            var self = this;
            var data = {
                id: self.deleteModel().Id()
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/Servers/DeleteServerConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Server deleted successfully");
                    if (self.deleteCallback) {
                        self.deleteCallback();
                    }
                    $(modal).modal("hide");
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        ServerActions.prototype.viewServerPasswordConfirm = function (theId, name) {
            var self = this;
            self.passwordModel(new ServerPasswordModel());
            self.passwordModel().ServerId(theId);
            tools.editModal({
                title: "View Server - " + name + " password",
                buttonTitle: "View",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    $(event.currentTarget).button("loading");
                    self.viewServerPassword(event.currentTarget, modal);
                },
                opened: function (modal) {
                    $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'server-viewpassword-template', data: passwordModel }\"></div>");
                    ko.applyBindings(self, modal);
                }
            });
        };
        ServerActions.prototype.viewServerPassword = function (btn, modal) {
            var self = this;
            var data = ko.mapping.toJS(self.passwordModel);
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/Servers/ViewPasswordConfirmation",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    if (self.passwordCallback) {
                        self.passwordCallback(result.Data);
                    }
                    $(modal).modal("hide");
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        ServerActions.prototype.loginToServer = function (ipAddress, domain) {
            var self = this;
            tools.ajaxGet({
                url: "/CustomerServers/GetLoginToken?ipAddress=".concat(ipAddress)
            }).done(function (result) {
                if (result.Success) {
                    log.log("impersonate success");
                    setTimeout(function () {
                        self.loginToServerLink(result.Data.url);
                    });
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        ServerActions.prototype.loginToServerLink = function (url) {
            var self = this;
            tools.alertModal({
                title: "Login To Server",
                html: "<a class=\"btn btn-info\" href=\"".concat(url, "\" target=\"_blank\">Log in to Server</a>"),
                buttonTitle: "Close",
                type: "info",
                modalOptions: {},
                open: function (modal) {
                    $('a', modal).on("click", function () {
                        $(modal).modal("hide");
                    });
                }
            });
        };
        return ServerActions;
    }());
    return ServerActions;
});
//# sourceMappingURL=serverActions.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/servers/serverActions.js
// module id = 89
// module chunks = 2